import React from 'react';
import ReactDOM from 'react-dom/client';
import '../frontend/lms/App.css';
import App from '../frontend/lms/App';

const root = document.getElementById('root');
if (root) ReactDOM.createRoot(root).render(<App />);
